export const PRIMARY = '#965ba5';